/*
 * Copyright '2024' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
export class ToastsConstants {
}
ToastsConstants.GLOBAL_KEY = 'window.sirius.shared.toasts';
ToastsConstants.DEFAULT_LIFETIME = 5; //seconds
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidG9hc3RzLmNvbnN0YW50cy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9zaGFyZWQvdG9hc3RzL3RvYXN0cy5jb25zdGFudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7O0dBRUc7QUFDSCxNQUFNLE9BQU8sZUFBZTs7QUFDRCwwQkFBVSxHQUFHLDZCQUE2QixDQUFDO0FBQzNDLGdDQUFnQixHQUFHLENBQUMsQ0FBQyxDQUFDLFNBQVMifQ==